/**
 * 分页hook, 用来简化分页操作
 */
import {useMemo, useState} from 'react';
import {TablePaginationConfig} from 'antd/lib/table/interface';

const DefaultPageSize = 20;

export default function usePagination(
    defaultPageSize: number = DefaultPageSize,
) {
    const initPageNo = 1;

    const [pagination, setPagination] = useState<PaginationAntD>({
        current: initPageNo,
        pageSize: defaultPageSize,
    });

    // 显示分页信息
    function showTotal(total: number, range: [number, number]) {
        return `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`;
    }

    const tableProps = (total: number | undefined) => ({
        pagination: {
            ...pagination,
            total: total || 0,
            showSizeChanger: true,
            showTotal,
        },
        onChange({current, pageSize}: TablePaginationConfig) {
            setPagination({
                current: current || initPageNo,
                pageSize: pageSize || defaultPageSize,
            });
        },
    });

    function gotoPage(current: number) {
        setPagination(pagination => ({...pagination, current}));
    }

    const params: Pagination = useMemo(
        () => ({
            pageNo: pagination.current,
            pageSize: pagination.pageSize,
        }),
        [pagination],
    );

    return {pagination, params, gotoPage, tableProps};
}
